import "./TripStyle.css";

function TripData(props){
    return (
        <div className="trip-card">
            <div className="t-image">
                <img src={props.image} alt="image"/>

            </div>
            <h3>{props.heading}</h3>
            <p>{props.text}</p>
        </div>
    );
}
export default TripData;